const appStartupTime = Date.now();
const ONE_DAY = 24 * 60 * 60 * 1000;

export const refreshAppIfOld = function (): void {
  if (typeof window === 'undefined') {
    return;
  }

  // Tests that fake time to be in the future and then perform a route change
  // may fail due to the refresh caused by refreshAppIfOld.
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'DO_NOT_REFRESH' does not exist on type '... Remove this comment to see the full error message
  if (window.DO_NOT_REFRESH) {
    return;
  }

  if (appStartupTime + ONE_DAY < Date.now()) {
    window.location.reload();
  }
};
